import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoObject16 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M5.33333 2.66669H3.33333V8.00002M3.33333 8.00002H2M3.33333 8.00002V13.3334H5.33333M10.6667 13.3334H12.6667V8.00002M12.6667 8.00002H14M12.6667 8.00002V2.66669H10.6667" stroke={iconColor} strokeWidth={1.5} strokeLinecap="square" />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoObject16;